import { MatDialogConfig } from '@angular/material/dialog';
import { MatSnackBarConfig } from '@angular/material/snack-bar';

// Dialog constants
export const dialogConfig: MatDialogConfig = {
  data: null,
  width: '800px',
  position: {
    top: '50px'
  }
};

// SnackBar constants
export const snackBarConfig: MatSnackBarConfig<any> = {
  duration: 3000,
  verticalPosition: 'top',
  horizontalPosition: 'right'
};

// Pagination constants
export const pageSizeOptions: number[] = [5, 10, 25];
export const pageSize = 10;

// RxJs constants
export const debounceTimeMilliseconds = 500;

// Validation constants
export const maxLength = 128;
export const maxValue = 2147483647;

// Role constants
export const roleStaff = 'ROLE_STAFF';
export const translationRead = 'TRANSLATION_READ';
export const translationModify = 'TRANSLATION_MODIFY';
export const staffRead = 'STAFF_READ';
export const staffModify = 'STAFF_MODIFY';
export const clientRead = 'CLIENT_READ';
export const clientModify = 'CLIENT_MODIFY';
export const userRead = 'USER_READ';
export const userModify = 'USER_MODIFY';
export const configRead = 'CONFIG_READ';
export const configModify = 'CONFIG_MODIFY';
export const messageRead = 'MESSAGE_READ';
export const messageModify = 'MESSAGE_MODIFY';
export const roleRead = 'ROLE_READ';
export const roleModify = 'ROLE_MODIFY';
export const paymentModify = 'PAYMENT_MODIFY';
export const paymentRead = 'PAYMENT_READ';
export const kycRead = 'KYC_READ';
export const kycModify = 'KYC_MODIFY';
export const auditLogRead = 'AUDIT_LOG_READ';
export const locationRead = 'LOCATION_READ';
export const locationModify = 'LOCATION_MODIFY';
export const deviceRead = 'DEVICE_MODIFY';
export const deviceModify = 'DEVICE_MODIFY';
export const privilegeRead = 'PRIVILEGE_MODIFY';
export const privilegeModify = 'PRIVILEGE_READ';
export const tokenRead = 'TOKEN_READ';
export const tokenModify = 'TOKEN_MODIFY';

export const userCanModify = 'STAFF_MODIFY';
export const systemAdmin = 'SYSTEM_ADMIN';

// User Types constants
export const platformUser = 'PLATFORM_USER';
export const platformStaff = 'STAFF';
export const clientUser = 'USER';

// Message Types constants
export const directMessage = 'direct';
export const predefinedAnswersMessage = 'predefinedAnswers';
export const promoMessage = 'promo';

// document types
export const documentTypes = ['IDENTITY_CARD', 'PASSPORT'];

// files
export const maxImageSize = 12452048;

// login
export const loginForm = 'login';
export const resetPasswordForm = 'reset-password';
export const rememberMeLogin = 'remember_me';

// forgot passowrd
export const emailForm = 'email';
export const newPasswordForm = 'new-password';

// user role
export const systemRole = 'SYSTEM_ROLE';

// errors
export const passChangeRequired = 'pass_change_required';

// filter
export const tableFilterDefaults = {
  page: 0,
  size: pageSize,
  sort: 'id,desc'
};
